import { Clock, LayoutGrid, Moon, Sun, Sunrise } from "lucide-react";

import { cn } from "@/lib/utils";

import { SHIFTS, type ShiftKey } from "./shifts";

const ICONS: Record<ShiftKey, typeof Sun> = {
  all: LayoutGrid,
  "9-14": Sunrise,
  "14-18": Sun,
  "18-21": Moon,
  none: Clock,
};

/** Work shifts of the board: each tab shows the leads to call in that slot. */
export const ShiftTabs = ({
  value,
  onChange,
  counts,
  currentSlot,
}: {
  value: ShiftKey;
  onChange: (shift: ShiftKey) => void;
  counts: Record<ShiftKey, number>;
  currentSlot: string | null;
}) => (
  <div
    role="tablist"
    aria-label="Turno de llamadas"
    className="flex gap-1 overflow-x-auto rounded-xl border bg-muted/40 p-1"
  >
    {SHIFTS.map((shift) => {
      const Icon = ICONS[shift.key];
      const isActive = value === shift.key;
      const isNow = shift.key === currentSlot;
      return (
        <button
          key={shift.key}
          type="button"
          role="tab"
          aria-selected={isActive}
          onClick={() => onChange(shift.key)}
          className={cn(
            "flex min-w-36 flex-1 items-center gap-3 rounded-lg px-3 py-2 text-left transition-colors",
            isActive
              ? "bg-background shadow-sm ring-1 ring-border"
              : "text-muted-foreground hover:bg-background/60 hover:text-foreground",
          )}
        >
          <span
            className={cn(
              "flex h-9 w-9 shrink-0 items-center justify-center rounded-full",
              isActive
                ? "bg-primary text-primary-foreground"
                : "bg-background text-muted-foreground",
            )}
          >
            <Icon className="h-4 w-4" />
          </span>
          <span className="flex min-w-0 flex-col">
            <span className="flex items-center gap-1.5 text-sm font-semibold text-foreground">
              {shift.label}
              {isNow ? (
                <span className="rounded-full bg-emerald-600 px-1.5 py-px text-[10px] font-semibold uppercase leading-tight text-white">
                  Ahora
                </span>
              ) : null}
            </span>
            <span className="text-xs text-muted-foreground">
              {shift.hours ? `${shift.hours} · ` : ""}
              {counts[shift.key]} por llamar
            </span>
          </span>
        </button>
      );
    })}
  </div>
);
